import Cookies from "js-cookie"
import {useEffect, useRef, useState} from "react"
import {v4 as uuidv4} from "uuid"

import Page from "@/components/Page"
import PageContent from "@/components/PageContent"
import ChatPanel from "@/components/ui/ChatPanel"
import StartAgain from "@/components/ui/StartAgain"
import UserInput from "@/components/ui/UserInput"
import {useTheme} from "@/hooks/useTheme"
import {useWebsocket} from "@/hooks/useWebsocket"
import {cn} from "@/lib/utils"

const BOT_CLIENT_ID_COOKIE_KEY = "BotClientId"

const ChatPage: React.FC = () => {
    const {theme} = useTheme()
    const [userInputEnabled, setUserInputEnabled] = useState<boolean>(true)
    const {connect, closeWebsocket, messages} = useWebsocket()

    const scrollRef = useRef<HTMLDivElement>(null)

    // useEffect(() => {
    //     if (scrollRef.current) {
    //         scrollRef.current.scrollIntoView({
    //             behavior: "smooth",
    //             inline: "center",
    //         })
    //     }
    // }, [scrollRef, messages, userInputEnabled])

    useEffect(() => {
        let clientId = Cookies.get(BOT_CLIENT_ID_COOKIE_KEY)
        if (clientId === undefined) {
            Cookies.set(BOT_CLIENT_ID_COOKIE_KEY, uuidv4(), {expires: 7, secure: true, sameSite: "none"})
        }

        const ws = connect()
        return () => {
            closeWebsocket(ws)
        }
    }, [])

    return (
        <Page
            className={cn(
                theme,
                "bg-background text-base font-normal text-[16px] leading-[133%] sm:text-[18px] text-foreground font-display border border-frame rounded-frame overflow-hidden no-scrollbar",
            )}
        >
            <PageContent>
                <div className="flex flex-col gap-4 h-screen justify-between overflow-hidden no-scrollbar">
                    <div className="flex-grow fixed left-0 top-0 p-3 overflow-hidden no-scrollbar">{/* <ChatHeader /> */}</div>
                    <div className="flex-grow place-content-start fixed left-0 right-0  top-[1px] bottom-[140px] overflow-auto p-[20px] sm:p-[30px]">
                        <ChatPanel setUserInputEnabled={setUserInputEnabled} />
                        <div className="mt-2" ref={scrollRef}></div>
                    </div>
                    <div className="h-[140px] pt-[20px] w-full fixed bottom-[0px] left-0 overflow-hidden no-scrollbar">
                        <UserInput enabled={userInputEnabled} />
                        <div className="w-full p-[20px] flex place-content-center">
                            <StartAgain />
                        </div>
                    </div>
                </div>
            </PageContent>
        </Page>
    )
}

export default ChatPage
